const alpineData = () => {
  return {
    downloadFile: async function (title, url, mimeType) {
      const w = window.open('/app/themes/hk-master/download.php?key=' + url.substring(url.lastIndexOf('/') + 1) + '&name=' + title);
    },
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.pageCertifications = alpineData;


document.addEventListener('DOMContentLoaded', function() {

  const bgClasses = 'bg-classic-primary bg-pride-cherry bg-dark-grass bg-pastel-cherry-light';
  const iconClasses = 'text-classic-primary text-pride-cherry text-dark-grass text-pastel-cherry-light';
  const textClasses = 'text-classic-white text-pride-white text-dark-black text-pastel-black';

  const tooltipTriggerList = [...document.querySelectorAll('[data-bs-toggle="tooltip"]')];
  tooltipTriggerList.forEach(trigger => {
    const text = trigger.getAttribute('title');
    if (text) {
      trigger.addEventListener('mouseenter', () => {
        trigger.insertAdjacentHTML(
          'afterend',
          `<p style="width:auto; height: auto" class="custom-tooltip py-3 px-4 mt-2 rounded-4 position-absolute ${bgClasses} ${textClasses}">
            <i style="left: 60px; bottom: 95%;" class="fa-solid fa-triangle position-absolute ${iconClasses} "></i>
            ${text}
          </p>`
        );
      });
      trigger.addEventListener('mouseleave', () => {
        trigger.nextSibling.remove();
      });
    }
  });
});
